import React from "react";
import { Box } from "../../design-system";
import { colors } from "../../design-system/colors";
import { CloseIcon } from "../../design-system/icons";
import { MODAL } from "../constants/accountText";

const CLOSE_BUTTON_SIZE = 24;

interface ModalHeaderProps {
  onClose: () => void;
}

const ModalHeader = ({ onClose }: ModalHeaderProps) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <Box
      component="span"
      sx={{
        color: colors.text[500],
        fontFamily: "Outfit, sans-serif",
        fontSize: "32px",
        fontWeight: 700,
        lineHeight: "37px",
      }}
    >
      {MODAL.TITLE}
    </Box>

    <Box
      component="button"
      aria-label={MODAL.CLOSE_ARIA_LABEL}
      onClick={onClose}
      sx={{
        width: `${CLOSE_BUTTON_SIZE}px`,
        height: `${CLOSE_BUTTON_SIZE}px`,
        borderRadius: "50%",
        backgroundColor: colors.background.buttonClose,
        border: "none",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        "&:hover": {
          backgroundColor: colors.button.iconButtonHoverBg,
        },
        "&:focus-visible": {
          outline: `2px solid ${colors.primary[500]}`,
          outlineOffset: "2px",
        },
      }}
    >
      <CloseIcon size={18} color={colors.text[500]} />
    </Box>
  </Box>
);

export default ModalHeader;
